import { SuperBannerConfiguration } from "../../models/SuperBannerConfiguration/SuperBannerConfiguration";

export function getEventIdsFromConfiguration(config: SuperBannerConfiguration): number[] {
    let eventIds: number[] = [];
    /* istanbul ignore next */
    if (config.SuperBannerItems) {
        config.SuperBannerItems.forEach(item => {
            /* istanbul ignore next */
            if (item.PickedEvent) {
                if (item.PickedEvent.IsOutright || item.PickedEvent.IsQA) {
                    eventIds.push(item.PickedEvent.EventID);
                } else {
                    eventIds.push(item.PickedEvent.MasterEventID);
                }
            }
        });
    }
    return eventIds;
}